import { render, staticRenderFns } from "./lottery-view.vue?vue&type=template&id=f0a9d104&scoped=true&"
import script from "./lottery-view.vue?vue&type=script&lang=ts&"
export * from "./lottery-view.vue?vue&type=script&lang=ts&"
import style0 from "./lottery-view.vue?vue&type=style&index=0&id=f0a9d104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a9d104",
  null
  
)

export default component.exports